export default "__VITE_ASSET__DtcVi7Iw__"